import { render, staticRenderFns } from "./stock-transfer-receive.vue?vue&type=template&id=893f7776&scoped=true"
import script from "./stock-transfer-receive.vue?vue&type=script&lang=js"
export * from "./stock-transfer-receive.vue?vue&type=script&lang=js"
import style0 from "./stock-transfer-receive.vue?vue&type=style&index=0&id=893f7776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893f7776",
  null
  
)

export default component.exports